import { CustomerType } from "../../../state/types"
import { CustomerTypePriceListPDFPage } from "./customerTypePriceListPDFPage"
import { useProductLoaders, useCategoryLoaders } from "../../../../products"
import { usePricesHooks } from "../../../../operations"
import { useEffect, useState } from "react"
import { PriceListPDFWrapper } from "./priceListPDFWrapper"

export const CustomerTypePriceListPDF = (props: { id: string, customerType: CustomerType, previewMode?: boolean, onLoad?: () => void }) => {
    const { id, customerType, previewMode, onLoad } = props
    const [calculatedProducts, setCalculatedProducts] = useState<any[]>([])
    const { product: priceProductHooks } = usePricesHooks()
    const productLoaderInitializer = useProductLoaders()
    const categoryLoaderInitializer = useCategoryLoaders()

    useEffect(() => {
        let isMounted = true;
        const loadData = async () => {
            const { loadAllProducts } = productLoaderInitializer();
            const { loadAllCategories } = categoryLoaderInitializer();
            const [pricesList, allProducts, allCategories] = await Promise.all([
                priceProductHooks.pricesList(customerType.id),
                loadAllProducts(true),
                loadAllCategories()
            ]);

            if (!isMounted) return;

            const excludedIds = (customerType.productYields || []).filter(py => py.isExcluded).map(py => py.productId);

            const flatList: any[] = [];
            const sortedCategories = allCategories.filter(cat => !cat.archived).sort((a, b) =>
                a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' })
            );

            sortedCategories.forEach(cat => {
                const catProducts = allProducts
                    .filter(p => p.categoryId === cat.id && !p.archived && !excludedIds.includes(p.id) && pricesList[p.id] != null)
                    .sort((a, b) => 
                        a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' })
                    );

                if (catProducts.length > 0) {
                    flatList.push({ isHeader: true, name: cat.name, id: `h-${cat.id}` });
                    catProducts.forEach(p => {
                        flatList.push({ ...p, calculatedPrice: pricesList[p.id] });
                    });
                }
            });
            setCalculatedProducts(flatList);
            if (flatList.length > 0) onLoad?.();
        }
        loadData();
        return () => { isMounted = false };
    }, [customerType.id, customerType.productYields]);

    if (calculatedProducts.length === 0) return null

    return (
        <PriceListPDFWrapper
            id={id}
            customerType={customerType}
            items={calculatedProducts}
            previewMode={previewMode}
            renderPDFPage={(pageIndex, ct, items, pagesAmount) => (
                <CustomerTypePriceListPDFPage
                    pageIndex={pageIndex}
                    customerType={ct}
                    products={items}
                    pagesAmount={pagesAmount}
                />
            )}
        />
    )
}
